import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Landmark, Plus, Trash2 } from "lucide-react";

const EMPTY = { banco: "", agencia: "", conta: "", tipo: "Corrente", titular: "", documento: "", ativo: false };

export default function BankAccountsConfig({ form, setForm }) {
  const contas = form.contas_bancarias || [];
  const update = (i, k, v) => setForm((f) => ({ ...f, contas_bancarias: contas.map((c, idx) => (idx === i ? { ...c, [k]: v } : c)) }));
  const add = () => setForm((f) => ({ ...f, contas_bancarias: [...contas, { ...EMPTY }] }));
  const remove = (i) => setForm((f) => ({ ...f, contas_bancarias: contas.filter((_, idx) => idx !== i) }));

  return (
    <div data-testid="bank-accounts-config" className="sm:col-span-2 bg-emerald-50/60 rounded-xl border border-emerald-100 p-4 space-y-4">
      <div className="flex items-start gap-3">
        <Landmark className="w-5 h-5 text-emerald-700 mt-0.5 shrink-0" />
        <div>
          <Label className="text-base font-semibold text-slate-800">Contas bancárias para transferência</Label>
          <p className="text-sm text-slate-500">Até 5 contas. Só as habilitadas aparecem para o contribuinte (com botão copiar). Se nenhuma estiver habilitada, a opção não aparece.</p>
        </div>
      </div>
      {contas.map((c, i) => (
        <div key={i} data-testid={`bank-account-${i}`} className={`bg-white rounded-xl border p-4 space-y-3 ${c.ativo ? "border-emerald-300" : "border-slate-200"}`}>
          <div className="flex items-center justify-between gap-3">
            <p className="font-semibold text-slate-800 text-sm">Conta {i + 1} {c.ativo ? <span className="ml-2 px-2 py-0.5 rounded-full text-[10px] font-bold bg-emerald-100 text-emerald-800">HABILITADA</span> : <span className="ml-2 px-2 py-0.5 rounded-full text-[10px] font-bold bg-slate-100 text-slate-500">DESATIVADA</span>}</p>
            <div className="flex items-center gap-3">
              <Switch data-testid={`bank-account-ativo-${i}`} checked={!!c.ativo} onCheckedChange={(v) => update(i, "ativo", v)} />
              <button type="button" data-testid={`bank-account-remove-${i}`} onClick={() => remove(i)} className="text-rose-500 hover:text-rose-700" aria-label="Remover conta"><Trash2 className="w-4 h-4" /></button>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
            <Field label="Banco *" testid={`bank-account-banco-${i}`} value={c.banco} onChange={(v) => update(i, "banco", v)} placeholder="Ex.: Banco do Brasil" />
            <Field label="Agência *" testid={`bank-account-agencia-${i}`} value={c.agencia} onChange={(v) => update(i, "agencia", v)} placeholder="0000-0" />
            <Field label="Conta *" testid={`bank-account-conta-${i}`} value={c.conta} onChange={(v) => update(i, "conta", v)} placeholder="00000-0" />
            <div>
              <Label className="text-sm font-semibold text-slate-700">Tipo</Label>
              <select data-testid={`bank-account-tipo-${i}`} value={c.tipo || "Corrente"} onChange={(e) => update(i, "tipo", e.target.value)} className="mt-1.5 h-11 w-full rounded-xl border border-slate-200 bg-white px-3 text-base">
                <option>Corrente</option>
                <option>Poupança</option>
                <option>Pagamento</option>
              </select>
            </div>
            <Field label="Titular" testid={`bank-account-titular-${i}`} value={c.titular} onChange={(v) => update(i, "titular", v)} placeholder="Nome do titular" />
            <Field label="CPF/CNPJ do titular" testid={`bank-account-documento-${i}`} value={c.documento} onChange={(v) => update(i, "documento", v)} placeholder="00.000.000/0000-00" />
          </div>
        </div>
      ))}
      {contas.length < 5 && (
        <button type="button" data-testid="bank-account-add" onClick={add} className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-white border border-emerald-300 text-emerald-800 font-semibold text-sm hover:bg-emerald-50 transition-colors">
          <Plus className="w-4 h-4" /> Adicionar conta ({contas.length}/5)
        </button>
      )}
    </div>
  );
}

function Field({ label, value, onChange, placeholder, testid }) {
  return (
    <div>
      <Label className="text-sm font-semibold text-slate-700">{label}</Label>
      <Input data-testid={testid} value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} className="mt-1.5 h-11 text-base rounded-xl" />
    </div>
  );
}
